export default {
  title: {
    create: 'Envío',
    templates: 'Plantillas',
    payment: 'Saldo',
    support: 'Soporte',
    jivosite: 'Soporte'
  }
}
